export const omit = (object: any, keyToRemove: string) => {
  const stringObject = JSON.stringify(object, (key, value) => {
    if (key === keyToRemove) {
      return undefined;
    }
    return value;
  });
  return JSON.parse(stringObject);
};
